<div v-if="shouldRenderConfig && getShowCostCenter" v-bind:class="getClassName">
    <div class="matrix_costCenterLabel">{{ $t(name) }}</div>
    <input type="text" v-model="costCenter" :placeholder="$t('Enter number')" name="cost_center_number"/>
</div>

